 import React from 'react';
 import './customCheckbox.css';

 const CustomCheckbox = ({ label, checked, onChange }) => {
  return (
    <div className="custom-checkbox">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <label>{label}</label>
    </div>
  );
 };

 export default CustomCheckbox;